module.exports = __webpack_public_path__ + "static/media/h320_5.f976fe640184bccb53ea968981ed4748.png";